import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { StoryCard } from 'legacyComponents/cards/types/story';

import { clientStore } from 'apps/client/app';
import { InitiativeStoriesManager } from 'apps/initiative/tabs/stories/appManager';

@withNamespaces()
@observer
export class InitiativeStoriesTab extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new InitiativeStoriesManager(
      this.props.initiativeManager,
      this.props,
    );
  }

  render() {
    const { initiativeManager } = this.props;
    const { initiative } = initiativeManager;
    const {
      title,
      canUpdate,
      inSpace: { whichTypes },
    } = initiative;

    const stories = this.appManager.storiesConn.arrayApp;

    return (
      <MainWrapper>
        <DocumentHead title={`${title} - Stories`} />
        <CardSection
          title='All Stories'
          tooltip='Create new story'
          createHandler={
            whichTypes.includes('Story')
              ? () => clientStore.routerStore.navigate('home.newStory')
              : ''
          }
          owner={canUpdate}
          ownerName={title}
          cardApp={stories}
          CardComponent={StoryCard}
          noDataCardType='story'
          gridColumns={2}
          last
          noCount
          initiative
        />
      </MainWrapper>
    );
  }
}

InitiativeStoriesTab.propTypes = {
  initiativeManager: PropTypes.object,
  params: PropTypes.object,
  routeName: PropTypes.string,
  t: PropTypes.func,
};
